import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html'
})
export class ConfirmationModalComponent {
  title = 'Atenção';
  content: any;
  cancelText = 'Não';
  confirmText = 'Sim';
  hideCancelButton = false;

  constructor(public dialogRef: MatDialogRef<ConfirmationModalComponent>) { }

  close() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
